import { render } from "./LabDocumentFolders.vue?vue&type=template&id=7d9a4cfe"
import script from "./LabDocumentFolders.vue?vue&type=script&lang=js"
export * from "./LabDocumentFolders.vue?vue&type=script&lang=js"

import "./LabDocumentFolders.vue?vue&type=style&index=0&id=7d9a4cfe&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/labDocuments/LabDocumentFolders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d9a4cfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d9a4cfe', __exports__)) {
    console.log('reload')
    api.reload('7d9a4cfe', __exports__)
  }
  
  module.hot.accept("./LabDocumentFolders.vue?vue&type=template&id=7d9a4cfe", () => {
    console.log('re-render')
    api.rerender('7d9a4cfe', render)
  })

}


export default __exports__